var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntertainment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.20167V15.7917C9 15.9442 9.16469 16.051 9.29944 15.9747L14.8989 12.6797C15.0337 12.6035 15.0337 12.4052 14.8989 12.3289L9.29944 9.03386C9.16469 8.94234 9 9.04912 9 9.20167Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7176 17.2445C18.4624 19.4501 16.4113 21.0277 13.9622 21.671C11.4977 22.3296 8.94145 21.9926 6.75255 20.7213C4.54834 19.4654 2.97171 17.413 2.32882 14.9623C1.67062 12.5116 2.00737 9.93843 3.27785 7.74816C4.54834 5.54256 6.59948 3.98026 9.0486 3.32165C9.85987 3.10722 10.6865 3 11.5283 3C13.1815 3 14.8193 3.44418 16.2582 4.27128C18.4624 5.54256 20.0237 7.59499 20.6819 10.0457C21.3248 12.481 20.9881 15.0542 19.7176 17.2445ZM18.9982 10.4898C18.4624 8.48335 17.1766 6.81384 15.3857 5.77231C14.1918 5.08306 12.86 4.73078 11.513 4.73078C10.8395 4.73078 10.166 4.82268 9.4925 5.00648C7.48728 5.54256 5.81882 6.82916 4.77794 8.6212C3.73707 10.4132 3.46154 12.4963 3.99728 14.5028C4.53303 16.5093 5.81882 18.1788 7.60974 19.2203C8.80369 19.9096 10.1354 20.2618 11.4824 20.2618C12.1559 20.2618 12.8294 20.1699 13.5029 19.9861C15.5082 19.4501 17.1766 18.1635 18.2175 16.3714C19.2584 14.5794 19.5339 12.4963 18.9982 10.4898Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntertainment);
export default __webpack_public_path__ + "static/media/Entertainment.8cec8641d75c35fac03c0ea9e5dadd35.svg";
export { ForwardRef as ReactComponent };